import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from 'react';
/**
 * Maps `CoverageGeoObject.sk` to their {@link CoverageReport}s
 */
const defaultCoverageReportMap = {};
/** Coverage Reports Context */
export const CoverageReportContext = createContext({
    retrievingReports: false,
    coverageReportMap: structuredClone(defaultCoverageReportMap),
    selectedReports: [],
    selectedReportsHash: '',
    setSelectedReports: () => { },
});
export const CoverageReportProvider = ({ children, retrievingReports, coverageReportMap, selectedReports, selectedReportsHash, setSelectedReports, }) => {
    return (_jsx(CoverageReportContext.Provider, { value: { retrievingReports, coverageReportMap, selectedReports, selectedReportsHash, setSelectedReports }, children: children }));
};
